/**
 * Created by Roman T on 11/28/2017.
 */
var BpoiSwitchesController = (function () {
    function BpoiSwitchesController(env, $filter, DTS, $stateParams, $state, socket, $scope, settings, admin, $mdDialog, Dialog) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.settings = settings;
        this.admin = admin;
        this.$mdDialog = $mdDialog;
        this.Dialog = Dialog;
        this.table = { sortType: '_link', sortReverse: false, search: '', filter: false, filterParams: {} };
        this.changeInitiated = false;
        this.bpoiLoaded = false;
        this.comments = [];
        this.socket.forward('bpoiview.getCtySampling', this.$scope);
        this.$scope.$on('socket:bpoiview.getCtySampling', function (event, data) {
            _this.iotCountries = data.iotCountries;
            _this.iotCountriesBackUp = _.cloneDeep(data.iotCountries);
            _this.countries = data.countries;
            _this.prepareBpoiTable(data.iotCountries);
            _this.comments = data.comments;
            _this.commentsBackUp = _.cloneDeep(data.comments);
            _this.bpoiLoaded = true;
            _this.changeInitiated = false;
            _this.iots = data.iots;
        });
    }
    BpoiSwitchesController.prototype.$onInit = function () {
        this.admin.getBpoiSetup();
    };
    BpoiSwitchesController.prototype.saveSourceChanges = function (e) {
        var _this = this;
        var items = {
            cancelMessage: 'Cancel',
            dialogName: 'Save BPOI Switches',
            message: 'Please confirm submission:',
            okMessage: 'Save'
        };
        this.Dialog.YesNoForm(undefined, items, 'yes-no.html').then(function (dResult) {
            var changedFields = [];
            if (dResult.confirm) {
                _this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        doc: {
                            comments: _this.comments,
                            countries: _this.countries,
                            iotCountries: _this.iotCountries,
                            iots: _this.iots
                        },
                        function: 'setBpoiSetupBackend',
                        script: '/admin/bpoi-enabler',
                        user: _this.env.user
                    }
                });
                _this.changeInitiated = false;
            }
        });
    };
    BpoiSwitchesController.prototype.resetSourceChanges = function (e) {
        this.iotCountries = _.cloneDeep(this.iotCountriesBackUp);
        this.comments = _.cloneDeep(this.commentsBackUp);
        this.changeInitiated = false;
    };
    BpoiSwitchesController.prototype.checkBpoiTable = function (iot, country, field) {
        var _this = this;
        this.changeInitiated = true;
        angular.forEach(this.iotCountries, function (iotArea) {
            if (iotArea.key === iot) {
                angular.forEach(iotArea.values, function (cty) {
                    if (cty.country === country) {
                        cty.startDate = new Date(cty.startDateFormated).getTime();
                        cty.endDate = new Date(cty.endDateFormated).getTime();
                        cty.isLineValid = cty.startDateFormated <= cty.endDateFormated;
                        var value = '';
                        switch (field) {
                            case 'start date':
                                value = cty.startDateFormated.toJSON();
                                break;
                            case 'end date':
                                value = cty.endDateFormated.toJSON();
                                break;
                            case 'GE Yes':
                                value = cty.geYes;
                                break;
                            case 'GE No':
                                value = cty.geNo;
                                break;
                            case 'Designation':
                                value = cty.designation;
                                break;
                            default:
                        }
                        _this.comments.push({
                            comment: "Changed " + field + " to " + value + "  for country: " + country,
                            editedBy: _this.env.user.email,
                            timestamp: new Date().getTime()
                        });
                    }
                });
            }
        });
    };
    BpoiSwitchesController.prototype.prepareBpoiTable = function (countries) {
        angular.forEach(countries, function (country) {
            angular.forEach(country.values, function (ctr) {
                ctr.startDateFormated = ctr.startDateFormated ? new Date(ctr.startDateFormated) : ctr.startDate ? new Date(parseInt(ctr.startDate, 10)) : new Date(Date.now());
                ctr.endDateFormated = ctr.endDateFormated ? new Date(ctr.endDateFormated) : ctr.endDate ? new Date(parseInt(ctr.endDate, 10)) : new Date(Date.now());
                ctr.isLineValid = ctr.startDateFormated < ctr.endDateFormated;
            });
        });
    };
    BpoiSwitchesController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'settings', 'admin', '$mdDialog', 'Dialog'];
    return BpoiSwitchesController;
}());
var BpoiSwitchesComponent = (function () {
    function BpoiSwitchesComponent() {
        this.templateUrl = 'bpoi-switches.html';
        this.controllerAs = 'vm';
        this.controller = BpoiSwitchesController;
    }
    return BpoiSwitchesComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg');
})
    .component('viewBpoiswitchSection', new BpoiSwitchesComponent());

//# sourceMappingURL=bpoiswitches-view.component.js.map
